import { Spinner } from '@uikit/components/Spinner';

export const LoadingScreen = () => {
  return (
    <div className="flex absolute top-1/2 left-1/2 justify-center items-center">
      <Spinner size="large" variant="secondary" />
    </div>
  );
};
